import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";

const EmployeeSalaryTaxTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onChange = () => { },
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">{t('employee.no')}</div>,
      dataIndex: "no",
      key: "no",
      align: "center",
    },
    {
      title: <div className="text-table">{t('salary.label.items')}</div>,
      dataIndex: "items",
      key: "items",
    },
    {
      title: <div className="text-table">{t('expense.expense-detail.amount')}</div>,
      dataIndex: "amount",
      key: "amount",
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeSalaryTaxTable;
